import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TaskaddPageRoutingModule } from './taskadd-routing.module';

import { TaskaddPage } from './taskadd.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TaskaddPageRoutingModule
  ],
  declarations: [TaskaddPage]
})
export class TaskaddPageModule {}
